import { memo } from 'react'

import { Subheader2 } from '@collaborate-health/uikit'

export interface ArticleNameProps {
  name: string
}

const ArticleName: React.FC<ArticleNameProps> = ({ name }) => {
  return (
    <Subheader2 fontWeight={700} mr={1} title={name} noWrap>
      {name}
    </Subheader2>
  )
}

export default memo(ArticleName)

